import { convertLocalizedNumberStringToFloat, isValidLocalizedNumberString } from "@core/utils";
import { ValidationInputType } from "@generation/core";
import { AbstractValidation } from "@generation/form/src/Validations/AbstractValidation";
import { CustomErrorMessage } from "@generation/form/src/Validations/ValidationHelper";
import { translate } from "../Locales/translator";

export enum AmountConditionType {
  GreaterThan = "GreaterThan",
  GreaterThanOrEqual = "GreaterThanOrEqual",
  SmallerThan = "SmallerThan",
  SmallerThanOrEqual = "SmallerThanOrEqual"
}

export class AmountConditionValidation extends AbstractValidation {
  key: string;

  constructor(
    public readonly conditionAmount: number,
    public readonly amountConditionType: AmountConditionType,
    customErrorMessage?: CustomErrorMessage,
    public readonly amountPrefix?: string
  ) {
    super(customErrorMessage);
    this.key = `AmountCondition_${this.amountConditionType}`;
  }

  validate = (value: ValidationInputType) => {
    if (!value) {
      return true;
    }
    if (!isValidLocalizedNumberString(value as unknown as string)) {
      return false;
    }
    const valueToCheck = convertLocalizedNumberStringToFloat(value as unknown as string) ?? 0;
    switch (this.amountConditionType) {
      case AmountConditionType.GreaterThan:
        return valueToCheck > this.conditionAmount;
      case AmountConditionType.GreaterThanOrEqual:
        return valueToCheck >= this.conditionAmount;
      case AmountConditionType.SmallerThan:
        return valueToCheck < this.conditionAmount;
      case AmountConditionType.SmallerThanOrEqual:
        return valueToCheck <= this.conditionAmount;
      default:
        return false;
    }
  };

  defaultMessage = (label: string): string => {
    let amount = this.conditionAmount.toString();
    if (this.amountPrefix) {
      amount = `${this.amountPrefix} ${amount}`;
    }

    switch (this.amountConditionType) {
      case AmountConditionType.GreaterThan:
        return translate("Generation_Form_{label}MoetGroterZijnDan{amount}", {
          label: label,
          amount: amount
        });
      case AmountConditionType.GreaterThanOrEqual:
        return translate("Generation_Form_{label}MoetMinimaal{amount}Zijn", {
          label: label,
          amount: amount
        });
      case AmountConditionType.SmallerThan:
        return translate("Generation_Form_{label}MoetKleinerZijnDan{amount}", {
          label: label,
          amount: amount
        });
      case AmountConditionType.SmallerThanOrEqual:
        return translate("Generation_Form_{label}MagMaximaal{amount}Zijn", {
          label: label,
          amount: amount
        });
      default:
        return "";
    }
  };
}
